import { Routes, Route, Navigate } from 'react-router-dom';
import { WelcomePage } from './components/WelcomePage/WelcomePage';
import { PrivacyPolicy } from './components/PrivacyPolicy/PrivacyPolicy';
import { TermsAndConditions } from './components/TermsAndConditions/TermsAndConditions';

function App() {
  return (
    <Routes>
      <Route path="/"                   element={<WelcomePage />} />
      <Route path="/privacy-policy"     element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="*"                   element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
